// React
import React from 'react';

// Styles
import '../styles/GameCard.css';

// Props du composant GameCard
interface GameCardProps {
    title: string;
    subtitle: string;
    image: string;
    backgroundColor?: 'red' | 'blue';
    width?: string;
    onClick?: () => void;
}

// Composant GameCard pour afficher une carte de jeu avec image et texte
const GameCard: React.FC<GameCardProps> = ({
    title,
    subtitle,
    image,
    backgroundColor,
    width,
    onClick,
}) => {
    return (
        <div className='game-card-wrap'>
            <div
                className={`game-card ${
                    backgroundColor === 'red' ? 'game-card--red' : 'game-card--blue'
                }`}
                onClick={onClick}
            >
                <div className='game-card__content'>
                    <p>{subtitle}</p>
                    <h2>{title}</h2>
                </div>
                <img
                    src={image}
                    alt={title}
                    style={{ width: width, height: 'auto' }}
                    className={`${backgroundColor === 'red' ? 'game-card__image' : ''}`}
                />
            </div>
            <div
                className={`game-card__shadow game-card__shadow${
                    backgroundColor === 'red' ? 'red' : 'blue'
                }`}
            ></div>
        </div>
    );
};

export default GameCard;
